import React from 'react'

const Error = () => {
  return (
    <div><h1>Error You are try to acces wrong page</h1></div>
  )
}

export default Error